import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  Flex,
  Input,
} from '@chakra-ui/react'
import { Button } from './components/Button'
import * as T from '../../components/Table'
import { ListModal } from './ListModal'

export function ModalContatos({ list, cliente }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button onClick={onOpen} size="sm" maxW="100px" w="100%">
        {list?.length} Contatos
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent maxH="90vh" overflowY="auto">
          <ModalHeader>Lista de Contatos do cliente - {cliente}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <T.Table>
              <T.Thead>
                <T.Tr>
                  <T.Th>Nome</T.Th>
                  <T.Th>Telefone</T.Th>
                  <T.Th>Celular</T.Th>
                  <T.Th>Email</T.Th>
                  <T.Th>Contato</T.Th>
                </T.Tr>
              </T.Thead>
              <T.Tbody>
                <ListModal list={list} />
              </T.Tbody>
            </T.Table>
          </ModalBody>

          <ModalFooter
            position="sticky"
            bottom="0"
            bgColor="white"
            borderTop="1px solid #CFCFCF"
            borderBottomLeftRadius="md"
            borderBottomRightRadius="md"
            p={2}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
